import React from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { AbsenceFullDayIcon } from 'redesign/components/atoms/Icon'
import TimelineIconText from 'redesign/components/molecules/timeline-icon-text'
import { formatDate } from 'redesign/shared/date'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { newDateWithoutTime } from 'utils/date'
import { ABSENCE_TYPE_TRANSLATIONS } from '../constants'
import { Container, DatesWrapper } from '../styles'
import type { TimelineAbsenceDatesProps } from '../types'

const MixedAbsenceDates: React.FC<TimelineAbsenceDatesProps> = ({ dates }) => {
  const { palette } = useTheme()
  const { t, locale } = useFavurTranslation()

  return (
    <Container>
      <TimelineIconText icon={AbsenceFullDayIcon} color={palette.text.secondary}>
        <Typography color={palette.text.primary} variant="body2">
          {t('absenceType.mixed')}
        </Typography>
      </TimelineIconText>
      {dates?.map(({ date, type: dateType }) => (
        <DatesWrapper key={date}>
          <Typography variant="body2">
            {formatDate({
              date: newDateWithoutTime(date),
              dateFormat: DATE_FORMAT_VARIANTS.shortWithWeekday,
              t,
              locale,
            })}
          </Typography>
          <Typography variant="body2">{t(ABSENCE_TYPE_TRANSLATIONS[dateType ?? 'free'])}</Typography>
        </DatesWrapper>
      ))}
    </Container>
  )
}

export default MixedAbsenceDates
